import {Dialog, DialogActions, DialogContent, DialogContentText} from "@mui/material";
import React from "react";
import {Button} from "react-bootstrap";

function DetailListDialog(props) {

    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            aria-labelledby="responsive-dialog-title">
            <DialogContent style={{paddingTop: '10px', paddingBottom: '10px'}}>
                <DialogContentText>
                    {props.list}
                </DialogContentText>

            </DialogContent>
            <DialogActions style={{borderTop: '1px solid #dee2e6',alignSelf: 'center'}}>
                <Button onClick={props.handleClose}  variant="secondary" size="sm">
                    Kapat
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default DetailListDialog;